import { HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { TradingExchangeOrder, RegulatoryInfo } from '../../models/common/trading-common.model';

import { TradingServiceStrategy } from './trading-service-strategy.service';
import { TRADING_PLATFORM } from '../../utils/trading-constants';
import { Injectable } from "@angular/core";

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    })
};

@Injectable()
export class RetailTradingServiceStrategy extends TradingServiceStrategy {

    private static SUPPORTED_PLATFORM = TRADING_PLATFORM.RETAIL;

    support(platform: string): boolean {
        return RetailTradingServiceStrategy.SUPPORTED_PLATFORM === platform;
    }

    public getEstimatedCommission(order: TradingExchangeOrder): Observable<any> {
        throw new Error('This operation is not supported on the retail platform');
    }

    public getOrderDateTimeStamp(accountNum: string, tranCode: string): Observable<any> {
        throw new Error('This operation is not supported on the retail platform');
    }

    public validateOrderDateTimes(regInfo: RegulatoryInfo): Observable<any> {
        throw new Error('This operation is not supported on the retail platform');
    }

    public getTradingSettings(ibdId: string, assetType: string, role?: string) {
      // avoid to call trading settings API for retails account, just respond with empty array
      let resp = {
        errorCode: 0,
        errorDescription: 'SUCCESS',
        errorMessage: null,
        response: {
            tradeDefaultSettingList: []}
      };

      return of(resp);
    }

    public getAccounts(): Observable<any> {
        return this.http.get(this.getBaseUrl() + '/accounts', httpOptions );
    }

    opraData(NONPROFDATA: any, NASDAQDATA: any, OPRADATA: any, NSPDDATA: any, PROFDATA: any): Observable<any> {
        const mergedreq = Object.assign(NONPROFDATA, NASDAQDATA, OPRADATA, NSPDDATA, PROFDATA);
        return this.http.post(this.getBaseUrl() + '/update-exchange-agreement', mergedreq, httpOptions);
    }

    public getExchangeDetails(symId: string): Observable<any> {
        throw new Error('This operation is not supported on the retail platform');
    }

    public getTrailingDetails(): string {
        return '?includeTrailers=true';
    }
}
